export default "__VITE_PUBLIC_ASSET__c9c371d3__"